<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.technical__6_environmental_system')}}</h4>
    <p class="white-space-pre">{{$t('medium_grant.technical__6_environmental_system_sub')}}</p>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4 mb-4">
          <a class="link-download" :href="downloadFiles[$i18n.locale]" target="_blank">{{$t('medium_grant.technical__6_environmental_download_esms')}}</a>
          <p class="mt-4">{{$t('medium_grant.technical__6_environmental_upload_esms')}}</p>
          <div class="mt-3">
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionEsmsQuestionaire" :file-data="GrantForm.files.technical.revisionEsmsQuestionaire" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionEsmsQuestionaire"></upload-file>
          </div>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.technical.environmentalEsms"
            >
            </textarea>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <h4 class="card-title mt-4">{{$t('medium_grant.revised_document_upload__other_esms_documents_card_title')}}</h4>
        <p>{{$t('medium_grant.document_upload__other_documents_info')}}</p>
        <table class="mt-5 mb-2" width="100%">
          <thead>
            <th>Name</th>
            <th>Upload</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GrantForm.revisionModel.technical.otherESMSDocuments" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('medium_grant.revised_document_upload__other_esms_documents_placeholder')"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.technical['otherESMSDocuments' + (index+1)]"
                  class="upload-file"
                  :file-data="GrantForm.files.technical['otherESMSDocuments' + (index+1)]"
                  :is-editable="GrantForm.isRevisionEditable"
                  :size-limit="GrantForm.fileSizeLimit"
                  :section="'technical.otherESMSDocuments' + (index + 1)"
                  >
                </upload-file>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          type="primary"
          @click.native="addOtherDocument"
          class="ml-2"
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('medium_grant.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('medium_grant.logical_framework__add_row_button_info')}}</span>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        downloadFiles: {
          en: '/files/en/BIOPAMA_AC_ESMS_Questionnaire_Medium-Grants_June_2019.docx',
          fr: '/files/fr/BIOPAMA_FA_SGES_Questionnaire_Subventions_Moyennes_June_2019.docx'
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      addOtherDocument()
      {
        if (!GrantForm.revisionModel.technical.otherESMSDocuments)
        {
          GrantForm.revisionModel.technical.otherESMSDocuments = [];
        }

        GrantForm.revisionModel.technical.otherESMSDocuments.push({});
        this.$forceUpdate();
      },
    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;
    &:hover {
      text-decoration: underline;
    }
  }
</style>
